
  document.addEventListener("DOMContentLoaded", function () {
    const track = document.querySelector('.slideshow-track');
    const slides = document.querySelectorAll('.slideshow .grid__item');
    const slideshow = document.querySelector('.slideshow');
    const totalSlides = slides.length;
    let currentIndex = 0;

    function goToSlide(index) {
      const offset = -index * 100;
      track.style.transform = `translateX(${offset}%)`;
      updateButtons(index);
    }

    function updateButtons(index) {
      document.querySelectorAll('.slideshow-button').forEach((btn, i) => {
        btn.classList.toggle('active', i === index);
      });
    }

    // Add dots
    const btnContainer = document.createElement('div');
    btnContainer.classList.add('slideshow-buttons');

    slides.forEach((_, i) => {
      const btn = document.createElement('button');
      btn.classList.add('slideshow-button');
      if (i === 0) btn.classList.add('active');
      btn.addEventListener('click', () => {
        currentIndex = i;
        goToSlide(i);
      });
      btnContainer.appendChild(btn);
    });

    if (window.innerWidth < 768) {
      slideshow.appendChild(btnContainer);
    }

    // --- Swipe Support ---
    let startX = 0;
    let endX = 0;

    track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    });

    track.addEventListener('touchmove', (e) => {
      endX = e.touches[0].clientX;
    });

    track.addEventListener('touchend', () => {
      const diff = startX - endX;

      if (diff > 50 && currentIndex < totalSlides - 1) {
        currentIndex++;
        goToSlide(currentIndex);
      } else if (diff < -50 && currentIndex > 0) {
        currentIndex--;
        goToSlide(currentIndex);
      }
    });
  });

